import styled from 'styled-components';

export const PlaybackWrapper = styled.div`
  display: flex;
  @media (max-width: 800px) {
    grid-column: 3/4;
  }
`;

export const PlaybackButton = styled.button`
  border: none;
  outline: none;
  font-size: ${props => (props.fontSize ? props.fontSize + 'px' : '24px')};
  background: none;
  line-height: 0;
  cursor: pointer;
  transition: all 0.2s;
  @media (hover: hover) {
    &:hover {
      color: #f9703e;
    }
  }

  @media (max-width: 800px) {
    font-size: ${props =>
      props.fontSize && props.minimized
        ? props.fontSize + 'px'
        : props.fontSize && !props.minimized
        ? props.fontSize * 2 + 'px'
        : '48px'};
  }
`;
